// extracted by mini-css-extract-plugin
export default {"tabGridLayout":"styles_tabGridLayout__kAfR8","rightColumnContainer":"styles_rightColumnContainer__f9bG1"};